import React from 'react';
import PropTypes from 'prop-types';

import PopupMessage from 'PointOfSale/modules/common/container/PopupMessage';

export const ProfileCardDeleteButton = props => {
  return (
    <PopupMessage
      item={props.settings}
      position={props.settings.position}
      messageText={props.settings.messageText}
      onConfirmClick={props.settings.onClick}
    />
  );
};

ProfileCardDeleteButton.propTypes = {
  settings: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/component/ProfileCardDeleteButton.js